<template>
<div class="container-fluid">
    <div class="row">
        <div class="col-xs-12">
          <label>Anchor</label>
          #<input class="form-control inlined" v-model="anchor" v-on:change="notifyChanges" />
        </div>
                <div class="col-xs-6">
                    <div class="form-group">
                        <label>Redirectpagina</label>
                        <input list="pages" class="form-control" @change="notifyChanges" @input="notifyChanges" v-model="redirectURL" placeholder="/">
                    </div>
                    <div class="form-group">
                        <label>voor Speedbooks Online</label>
                        <input type="text" class="form-control" @change="notifyChanges" @input="notifyChanges" v-model="voorSpeedbooksOnline" placeholder="0513 - 724 050">
                    </div>
                    <div class="form-group">
                        <label>voor Speedbooks Offline</label>
                        <input type="text" class="form-control" @change="notifyChanges" @input="notifyChanges" v-model="voorSpeedbooksOffline" placeholder="0513 - 820 131">
                    </div>
                    <div class="form-group">
                        <label>Support E-mail</label>
                        <input type="text" class="form-control" @change="notifyChanges" @input="notifyChanges" v-model="supportEmail" placeholder="support@speedbooks.com">
                    </div>

                    <div class="form-group">
                        <KendoValueComponent v-model="adresgegevens" label="Adresgegevens" :tools="tools"/>
                    </div>
                </div>
    </div>
</div>
</template>

<script type="application/javascript">
    export default {
        mounted()
        {
            for(let k of this.dataKeys)
                this.$watch(k, this.notifyChanges, { immediate: true });
        },
        methods: {
            notifyChanges()
            {
                let obj = {};
                for(let k of this.dataKeys)
                    Vue.set(obj, k, this[k]);
                this.$emit('change', obj);
            }
        },
        data()
        {
            let obj = {
                tools: ["cut", "copy", "paste", "bold", "italic", "superscript", "underline", "insertUnorderedList", "insertOrderedList", "createLink", "unlink", "cleanFormatting"],
                dataKeys: Object.keys(this.data),
            };
            for(let k of obj.dataKeys)
                Vue.set(obj, k, this.data[k]);
            return obj;
        },
        props: ['data']
    }
</script>
